import React, { useState, useEffect } from "react";
import { message, Pagination, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setLoader } from "../../../Slices/loaderSlice";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { AntdButton, SelectInput } from "../../../blueplanitUtils/InputField";
import { getAllIssuesThunk, updateIssueThunk } from "../../../Slices/IssueSlice";
import UserTaskEdit from "./UserTaskEdit";
import { getOptionsByPath } from "../../../utilsdata";
import { LEAD_INFORMATION, PRIORITY, USER_ISSUES, ISSUE_STATUS } from "../../../Dropdownmanager";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";

const UserIssues = () => {
    const dispatch = useDispatch();

    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const loginUser = useSelector((state) => state.loginUserInfo?.loginUserDetails);
    const userIssues = useSelector((state) => state.Issues.issues);
    // const { list: employees } = useSelector((state) => state.employees);
    const employees = useSelector(
        (state) => state.employee.AllEmployees || []
    );


    const [issues, setIssues] = useState([]);
    const [filterStatus, setFilterStatus] = useState("Not Started");
    const [filterPriority, setFilterPriority] = useState("");
    const [filterFromDate, setFilterFromDate] = useState(null);
    const [filterToDate, setFilterToDate] = useState(null);
    const [finalFilteredData, setFinalFilteredData] = useState([]);
    const [tempFilterStatus, setTempFilterStatus] = useState("Not Started");
    const [tempFilterPriority, setTempFilterPriority] = useState("");
    const [tempFilterFromDate, setTempFilterFromDate] = useState(null);
    const [tempFilterToDate, setTempFilterToDate] = useState(null);
    const [originalIssue, setOriginalIssue] = useState(null);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [editingIssue, setEditingIssue] = useState(null);
    const loginUserName = loginUser?.firstname + " " + loginUser?.lastname;
    const loginUserId =
        loginUser?._id ||
        loginUser?.id ||
        loginUser?.EmpID ||
        loginUser?.EmployeeID ||
        null;

    // useEffect(() => {
    //     dispatch(getEmployeesListThunk());
    // }, [dispatch]);

    useEffect(() => {
        if (loginUserId) {
            dispatch(getAllIssuesThunk());
        }
    }, [dispatch, loginUserId]);

    const getEmployeeName = (empId) => {
        if (!employees || employees.length === 0) return empId;

        const emp = employees.find(
            (e) => e.id === empId || e._id === empId
        );

        return emp ? `${emp.firstname} ${emp.lastname}` : empId;
    };


    useEffect(() => {
        if (userIssues?.length > 0) {
            const formattedIssues = userIssues.map((issue, index) => ({
                key: index,
                id: issue?._id,
                TaskID: issue.TaskID || "",
                TaskTitle: issue.TaskTitle || "",
                Tabname: issue.Tabname || "",
                Priority: issue.Priority || "",
                Deadline: issue.Deadline || "",
                issuedescription: issue.issuedescription || "",
                DateAndTime: issue.DateAndTime || "",
                UpdatedDate: issue.UpdatedDate || "",
                Status: issue.Status || "",
                Assignedto:
                    (() => {
                        let assignedArr = [];

                        if (Array.isArray(issue.Assignedto)) {
                            assignedArr = issue.Assignedto.map(item => {
                                if (!item) return "";

                                if (typeof item === "string" && item.includes(" ")) {
                                    return item;
                                }

                                if (typeof item === "object") {
                                    if (item.firstname && item.lastname) {
                                        return `${item.firstname} ${item.lastname}`;
                                    }
                                    return item._id || item.id || "";
                                }

                                return item;
                            });
                        } else if (issue.Assignedto) {
                            if (typeof issue.Assignedto === "string") {
                                assignedArr = [issue.Assignedto];
                            } else if (typeof issue.Assignedto === "object") {
                                if (issue.Assignedto.firstname && issue.Assignedto.lastname) {
                                    assignedArr = [`${issue.Assignedto.firstname} ${issue.Assignedto.lastname}`];
                                } else {
                                    assignedArr = [issue.Assignedto._id || issue.Assignedto.id || ""];
                                }
                            }
                        } else {
                            assignedArr = [];
                        }

                        return assignedArr;
                    })(),

                TechStack: issue.TechStack || "",
                HoursSpent: issue.HoursSpent || "",
                CodeSnippet: issue.CodeSnippet || "",
                Remarks: issue.Remarks || "",
                fileNames: issue.fileNames,
                urls: issue.urls,
                Instructions: issue.Instructions,
                FinalRemarks: issue.FinalRemarks,
            }));
            setIssues(formattedIssues);
        }
    }, [userIssues]);

    const handleUpdate = async () => {
        const errors = [];

        if (!editingIssue?.Status) errors.push("Status is required.");
        if (!editingIssue?.Remarks?.trim()) errors.push("Remarks are required.");

        if (editingIssue?.Status === "Completed" && !editingIssue?.CodeSnippet?.trim()) {
            errors.push("Code Snippet is required.");
        }

        if (errors.length > 0) {
            message.error(errors.join(" "));
            return;
        }

        const changed = Object.keys(originalIssue).some(
            key => JSON.stringify(originalIssue[key]) !== JSON.stringify(editingIssue[key])
        );

        if (!changed) {
            message.error("No changes detected. Please update the fields before submitting.");
            return;
        }

        try {
            dispatch(setLoader(true));
            const updateData = {
                _id: editingIssue.id,
                issuedescription: editingIssue.issuedescription,
                UpdatedDate: editingIssue.UpdatedDate,
                Tabname: editingIssue.Tabname,
                Status: editingIssue.Status,
                TechStack: editingIssue.TechStack,
                CodeSnippet: editingIssue.CodeSnippet,
                HoursSpent: editingIssue.HoursSpent,
                Assignedto: editingIssue.Assignedto,
                Remarks: editingIssue.Remarks,
                Instructions: editingIssue.Instructions,
                FinalRemarks: editingIssue.FinalRemarks,
            };

            await dispatch(updateIssueThunk(updateData));
            await dispatch(getAllIssuesThunk());

            message.success("Issue updated successfully!");
            setEditingIssue(null);
            setOriginalIssue(null);
        } catch (error) {
            message.error("Failed to update issue. Please try again.");
        } finally {
            dispatch(setLoader(false));
        }
    };


    const formatDateTimes = (dateString) => dateString ? dayjs(dateString, "YYYY-MM-DD").format("DD/MM/YYYY") : "N/A";

    function formatDateTime(timestamp) {
        const date = new Date(parseInt(timestamp));
        const formattedDate = date.toLocaleString('en-IN', {
            month: '2-digit', day: '2-digit', year: 'numeric',
            hour: 'numeric', minute: 'numeric', hour12: true,
        });
        const datee = formattedDate.replace(/\b(am|pm)\b/, match => match.toUpperCase());
        return datee === "Invalid Date" ? "-" : datee;
    }

    const columns = [
        { title: "Task ID", dataIndex: "TaskID", key: "TaskID", width: 80 },
        { title: "Tabname", dataIndex: "Tabname", key: "Tabname", width: 100 },
        { title: "Task Title", dataIndex: "TaskTitle", key: "TaskTitle", width: 150 },
        { title: "Issue Description", dataIndex: "issuedescription", key: "issuedescription", width: 120 },
        { title: "Priority", dataIndex: "Priority", key: "Priority", width: 80 },
        { title: "Dead Line", dataIndex: "Deadline", key: "Deadline", render: (text) => formatDateTimes(text), width: 120 },
        { title: "Created Date", dataIndex: "DateAndTime", key: "DateAndTime", render: (text) => formatDateTime(text), width: 160 },
        { title: "Updated Date", dataIndex: "UpdatedDate", key: "UpdatedDate", render: (text) => formatDateTime(text), width: 160 },
        {
            title: "Assigned To",
            dataIndex: "Assignedto",
            key: "Assignedto",
            width: 170,
            render: (_, record) => {
                const arr = Array.isArray(record.Assignedto) ? record.Assignedto : [];
                if (!arr.length) return "N/A";

                const names = arr.map(itemStr => {

                    const item = String(itemStr);


                    const emp = employees?.find(e => String(e._id) === item || String(e.id) === item);


                    if (emp) return `${emp.firstname} ${emp.lastname}`;


                    return item;
                });

                return names.join(", ");
            }

        },
        { title: "Guide Notes", dataIndex: "Instructions", key: "Instructions", render: (_, record) => record.Instructions || "N/A", width: 100 },
        { title: "Status", dataIndex: "Status", key: "Status", render: (_, record) => record.Status || "N/A", width: 100 },
        { title: "Tech Stack", dataIndex: "TechStack", key: "TechStack", render: (_, record) => record.TechStack?.join(",") || "N/A", width: 100 },
        { title: "Code Snippet", dataIndex: "CodeSnippet", key: "CodeSnippet", render: (_, record) => record.CodeSnippet || "N/A", width: 100 },
        { title: "Hours Spent", dataIndex: "HoursSpent", key: "HoursSpent", render: (_, record) => record.HoursSpent || "N/A", width: 100 },
        { title: "Remarks", dataIndex: "Remarks", key: "Remarks", render: (_, record) => record.Remarks || "N/A", width: 120 },
        {
            title: "Actions", key: "actions", width: 80, render: (_, record) => {
                const isDisabled = record.Remarks && record.FinalRemarks && record.Instructions;
                return (
                    <AntdButton
                        onClick={() => {
                            setEditingIssue(record);
                            setOriginalIssue(JSON.parse(JSON.stringify(record))); // store deep copy
                        }}
                        disabled={isDisabled}
                        style={{
                            backgroundColor: isDisabled ? "#ccc" : "#007bff",
                            color: isDisabled ? "#666" : "white",
                            border: "none", padding: "6px 12px",
                            borderRadius: "4px",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                        }}
                        label="Update"
                    />
                );
            }
        },
    ];

    useEffect(() => {
        if (!loginUserId && !loginUserName) {
            setFinalFilteredData([]);
            return;
        }

        const loginIdStr = loginUserId ? String(loginUserId) : null;
        const loginNameStr = loginUserName ? String(loginUserName) : null;

        const filteredList = issues.filter(issue => {
            const arr = Array.isArray(issue.Assignedto) ? issue.Assignedto : [];

            // normalize all assigned values to strings
            const normalized = arr.map(a => String(a));


            const matchesById = loginIdStr ? normalized.includes(loginIdStr) : false;
            const matchesByName = loginNameStr ? normalized.includes(loginNameStr) : false;

            return matchesById || matchesByName;
        });

        let final = filteredList;

        if (filterStatus) {
            final = final.filter(i => i.Status === filterStatus);
        }

        if (filterPriority) {
            final = final.filter(i => i.Priority === filterPriority);
        }

        if (filterFromDate) {
            final = final.filter(i => {
                const created = new Date(Number(i.DateAndTime));
                return created >= filterFromDate.toDate();
            });
        }

        if (filterToDate) {
            final = final.filter(i => {
                const created = new Date(Number(i.DateAndTime));
                return created <= filterToDate.toDate();
            });
        }

        setFinalFilteredData(final);
        setPagination(prev => ({ ...prev, current: 1 }));
    }, [issues, loginUserId, loginUserName, filterStatus, filterPriority, filterFromDate, filterToDate]);

    const handleSearch = () => {
        try {
            dispatch(setLoader(true));
            setFilterStatus(tempFilterStatus);
            setFilterPriority(tempFilterPriority);
            setFilterFromDate(tempFilterFromDate);
            setFilterToDate(tempFilterToDate);

            setTimeout(() => {
                dispatch(setLoader(false));
            }, 300);
        } catch (error) {
            console.error("Search Error:", error);
            dispatch(setLoader(false));
        }
    };

    const handleClearFilters = () => {
        try {
            dispatch(setLoader(true));
            setTempFilterStatus("Not Started");
            setTempFilterPriority("");
            setTempFilterFromDate(null);
            setTempFilterToDate(null);
            setFilterStatus("Not Started");
            setFilterPriority("");
            setFilterFromDate(null);
            setFilterToDate(null);

            setTimeout(() => {
                dispatch(setLoader(false));
            }, 300);
        } catch (error) {
            console.error("Clear Filters Error:", error);
            dispatch(setLoader(false));
        }
    };


    const start = (pagination.current - 1) * pagination.pageSize;
    const end = pagination.current * pagination.pageSize;
    const paginatedData = finalFilteredData.slice(start, end);


    return (
        <div className="page-wrapper">
            <div className="content container-fluid">

                {!editingIssue && (
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        marginBottom: "-10px"
                    }}>
                        <h3>My Tasks</h3>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                        }}>
                            <div style={{ minWidth: "150px" }}>
                                <SelectInput
                                    label="Status"
                                    value={tempFilterStatus}
                                    onChange={(value) => setTempFilterStatus(value)}
                                    options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, ISSUE_STATUS])}
                                    placeholder="Select Status"
                                    allowClear
                                    style={{ width: "100%" }}
                                />
                            </div>

                            <div style={{ minWidth: "150px" }}>
                                <SelectInput
                                    label="Priority"
                                    value={tempFilterPriority}
                                    onChange={(value) => setTempFilterPriority(value)}
                                    options={getOptionsByPath(NestedDatabucket, [LEAD_INFORMATION, PRIORITY])}
                                    placeholder="Select Priority"
                                    allowClear
                                    style={{ width: "100%" }}
                                />
                            </div>

                            <div style={{ minWidth: "160px" }}>
                                <label style={{
                                    display: "block",
                                    marginTop: "-12px",
                                    marginBottom: "4px",
                                    fontSize: "12px",
                                }}>
                                    Created From Date
                                </label>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    format="DD-MM-YYYY"
                                    value={tempFilterFromDate}
                                    onChange={(date) => setTempFilterFromDate(date ? date.startOf("day") : null)}
                                    placeholder="DD/MM/YYYY"
                                />
                            </div>

                            <div style={{ minWidth: "160px" }}>
                                <label style={{
                                    display: "block",
                                    marginTop: "-12px",
                                    marginBottom: "4px",
                                    fontSize: "12px",
                                }}>
                                    Created To Date
                                </label>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    format="DD-MM-YYYY"
                                    value={tempFilterToDate}
                                    onChange={(date) => setTempFilterToDate(date ? date.endOf("day") : null)}
                                    placeholder="DD/MM/YYYY"
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <AntdButton onClick={handleSearch} type="primary" htmlType="submit" label="Search" />
                                <AntdButton
                                    onClick={handleClearFilters}
                                    style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none' }}
                                    label="Clear"
                                />
                            </div>
                        </div>
                    </div>

                )}

                {editingIssue ? (
                    <UserTaskEdit
                        editingIssue={editingIssue}
                        setEditingIssue={setEditingIssue}
                        handleUpdate={handleUpdate}
                        NestedDatabucket={NestedDatabucket}
                        handleCancel={() => setEditingIssue(null)}
                    />
                ) : (
                    <>
                        <CustomGridTable
                            columns={columns}
                            Id="user-issues-table"
                            dataSource={paginatedData}
                            pagination={false}
                            rowKey="id"
                            scroll={{ x: 1300 }}
                            size="small"
                            style={{
                                backgroundColor: "white",
                                padding: "20px",
                                borderRadius: "8px",
                                width: "100%",
                                maxWidth: "100%",
                                tableLayout: "auto",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        />

                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                            <Pagination
                                current={pagination.current}
                                pageSize={pagination.pageSize}
                                total={finalFilteredData.length}
                                showSizeChanger
                                size="small"
                                onChange={(page, pageSize) => {
                                    setPagination({
                                        current: page,
                                        pageSize: pageSize,
                                    });
                                }}
                                onShowSizeChange={(current, pageSize) => {
                                    setPagination({
                                        current: 1,      // reset to first page
                                        pageSize: pageSize,
                                    });
                                }}
                            />

                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default UserIssues;